// extracted by mini-css-extract-plugin
export default {"container":"ingredient-icon_container__DyCQu","image":"ingredient-icon_image__+lwTK","overlay":"ingredient-icon_overlay__pB-lk"};